import {FOLDERS_ROUTE_NAME} from "../components/modules/file-browser/constants";

export default [
  {
    path: '/video',
    component: () => import('../components/VideoTable.vue'),
    children: [
      {
        path: '',
        name: 'video.index',
      },
      {
        path: ':type/:id',
        name: 'video.entity',
      },
    ],
  },
  {
    path: '/file/browser',
    component: () => import('../components/modules/file-browser/FileBrowser.vue'),
    children: [
      {
        path: ':tab',
        name: 'file.tab',
        children: [
          {
            path: '*',
            name: FOLDERS_ROUTE_NAME,
          }
        ]
      }
    ],
  },
  {
    path: '/prompt-generator',
    name: 'prompt-generator',
    component: () => import('../components/PromptGeneratorPage.vue')
  },
  {
    path: '/banner-builder',
    component: () => import('../components/common/dashboard/BannerBuilder.vue'),
    children: [
      {
        path: 'placements',
        name: 'banner.builder.placements',
        component: () => import('../components/common/dashboard/banner-builder/Placement.vue')
      },
      {
        path: 'upload-assets',
        name: 'banner.builder.upload-assets',
        component: () => import('../components/common/dashboard/banner-builder/UploadAssets.vue')
      },
      {
        path: 'manage-assets',
        name: 'banner.builder.manage-assets',
        component: () => import('../components/common/dashboard/banner-builder/UploadAssets.vue')
      },
    ],
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('../components/DashboardPage.vue'),
    children: [
      {
        path: 'display-ad',
        name: 'dashboard.display-ad',
        component: () => import('../components/common/dashboard/DisplayAd.vue'),
      },
      {
        path: 'retailer-banners',
        name: 'dashboard.retailer-banners',
        component: () => import('../components/common/dashboard/RetailerBanners.vue'),
      },
      {
        path: 'ai-pdf-creator',
        name: 'dashboard.ai-pdf-creator',
        component: () => import('../components/common/dashboard/AiPdfCreator.vue'),
      },
      {
        path: 'analyze-images',
        name: 'dashboard.analyze-images',
        component: () => import('../components/common/dashboard/AnalyzeImages.vue'),
      },
      {
        path: 'pdp-images',
        name: 'dashboard.mobile-hero',
        component: () => import('../components/common/dashboard/MobileHeroCreator.vue'),
      },
      {
        path: 'banner-builder',
        name: 'banner.builder',
        component: () => import('../components/common/dashboard/banner-builder/DashboardBannerBuilder'),
      },
      {
        path: 'template-psd',
        name: 'dashboard.template-psd',
        component: () => import('../components/common/dashboard/TemplatePsd.vue'),
      },
      {
        path: 'video-builder',
        name: 'dashboard.video.add',
        component: () => import('../components/common/dashboard/VideoCreator.vue'),
      },
      {
        path: 'sell-sheet',
        name: 'dashboard.sell-sheet',
        component: () => import('../components/common/dashboard/SellSheet.vue'),
      },
      {
        path: 'sell-sheet-v2',
        name: 'dashboard.sell-sheet-v2',
        component: () => import('../components/common/dashboard/SellSheetV2.vue'),
      },
    ],
  }
]
